import React from 'react'
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay
} from '@chakra-ui/react'
import TermsAndConditions from '@components/reward-points/terms-conditions'

interface TermConditionModalProps {
  isOpen: boolean
  onClose: () => void
  tc?: string
}

const TermConditionModal: React.FC<TermConditionModalProps> = ({
  isOpen,
  onClose,
  tc
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent maxW={'1400px'} mx={{ base: 5, lg: 10 }} margin={'auto'}>
        <ModalCloseButton />
        <ModalBody>
          {tc && (
            <div
              dangerouslySetInnerHTML={{
                __html: tc
              }}
            ></div>
          )}
          {!tc && <TermsAndConditions />}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default TermConditionModal
